import React from "react";
import BreadCrumb from "./BreadCrumb";

const InPatients = () => {
  return (
    <>
      <BreadCrumb
        image="images/breadcrumb.webp"
        title="Testimonials & Patients Stories"
        page="Patients / Testimonials & Patients Stories"
      />
    </>
  );
};

export default InPatients;
